
export const LOCAL_KEY = 'abcfg-ct-y-asadf'

export function setData(key,data) {
    window.localStorage.setItem(key || LOCAL_KEY, data)
}

export function getData(key) {
    return window.localStorage.getItem(key || LOCAL_KEY)
}

export function removeData(key) {
    window.localStorage.setItem(key || LOCAL_KEY, false)
    return window.localStorage.removeItem(key || LOCAL_KEY)
}
